import { Divider, type DividerProps } from '@chakra-ui/react';

export type UiDividerProps = DividerProps;

export const UiDivider = Divider;
